import React,{useState,useEffect} from "react";


const RangeSlider = ({setSliderVal,sliderVal }) => {
  
  
  
  const [value, setValue] = useState();
     useEffect(()=>{
      setValue(sliderVal?sliderVal:10)
     },[])
    return (
      <div className="range-slider">
        <input
          type="range"
          min="1"
          max="25"
          value={value}
          onChange={(e) => {setValue(e.target.value) ;setSliderVal(e.target.value)}}
          className="slider"
        />
        <div className="marks">
        {[1, 5, 10, 15, 20, 25].map((mark) => (
          <span
            key={mark}
            className={`mark ${value === mark ? 'active' : ''}`}
            style={{ left: `${mark*4}%` }}
          >
            {mark}
          </span>
        ))}
      </div>
        <div style={{background:"rgba(144, 202, 249,1)",padding:"20px",borderRadius:"50px",fontWeight:"999",fontSize:"20px"}}>Re-Attempts: {value}</div>
      </div>
    );
  };
  export default RangeSlider;